import {
  Injectable,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { tap } from 'rxjs/internal/operators/tap';
import { isPlatformBrowser } from '@angular/common';
import { ExpiryPopupService } from './expiry-popup.service';
import { SessionService } from './session.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SessionInterceptorService implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private platform,
    private expiryPopupService: ExpiryPopupService,
    private sessionService: SessionService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const request = () => {
      if (req.url.indexOf('/general/refreshsession') === -1) {
        this.sessionService.waitingOtherRequest = true;
        this.sessionService.setRequset(req);
      }

      return next.handle(req).pipe(
        tap(
          (response: HttpResponse<any>) => {
            if (response.status && response.status === 200) {
              this.sessionService.chechResponse(req);

              if (isPlatformBrowser(this.platform)) {
                this.expiryPopupService.startPopupTimer(true);
              }
            }
          },
          (error: HttpErrorResponse) => {
            if (isPlatformBrowser(this.platform) && error.status === 401) {
              this.expiryPopupService.openSessionPopup();
            }

            if (error.status) {
              this.sessionService.chechResponse(req);
            }
          }
        )
      );
    };

    if (
      this.sessionService.waitingForRefreshToken &&
      req.url.indexOf('/general/refreshsession') === -1
    ) {
      return this.waitRefreshToken(request);
    } else {
      return request();
    }
  }

  private waitRefreshToken(request) {
    return this.sessionService.refreshToken.pipe(switchMap(request));
  }
}
